import React, { useEffect, useState } from 'react';

import { Table, InlineEditColumnProps } from '@digital/ui';
import { getAllRelatorioExecucaoRotina, Historico } from '@app/api/parametro';
import { useRecoilValue } from 'recoil';
import { listHistoricoExecucaorotina } from '@app/state/atom';

interface TabelaProps {
}

const TableExecucaoRotina = (props: TabelaProps) => {
  const historicosRotinas = useRecoilValue(listHistoricoExecucaorotina)
  const customColumns = () => {
    const collunas = [
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },
      {
        title: 'Parâmetro',
        dataIndex: 'nomeParametro',
        width: '20%',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        width: '15%',
      },
      {
        title: 'Data/Hora',
        dataIndex: 'data',
        width: '25%',
      },
      {
        title: 'Estimativa da próxima execução',
        dataIndex: 'proximaExecucao',
        width: '10%',
      },
      {
        title: 'Observação',
        dataIndex: 'observacao',
        width: '30%',
      }
    ] as InlineEditColumnProps<Historico>[];
    return collunas;
  };

  return (
    <>
      <Table
        dataSource={historicosRotinas}
        columns={customColumns()}
        rowKey="id"
        pagination={false}
      />
    </>
  );
};

export default TableExecucaoRotina;
